import {
  Smile,
  User,
  UserCog,
  UserPlus,
  UserRoundPlus,
  Users,
  UsersRound,
  UserX,
} from 'lucide-react';
import { createLucideIcon } from '../createLucideIcon';

// People / account icons.
// GAP: MUI Person is filled; Lucide is outline-only, so Person and
// PersonOutline collapse to the same glyph.
export const PersonIcon = /* #__PURE__ */ createLucideIcon('Person', User);
export const PersonOutlineIcon = /* #__PURE__ */ createLucideIcon('PersonOutline', User);
export const PersonAddIcon = /* #__PURE__ */ createLucideIcon('PersonAdd', UserPlus);
export const PersonOffIcon = /* #__PURE__ */ createLucideIcon('PersonOff', UserX);
export const PeopleIcon = /* #__PURE__ */ createLucideIcon('People', Users);
export const GroupsIcon = /* #__PURE__ */ createLucideIcon('Groups', UsersRound);
export const GroupAddIcon = /* #__PURE__ */ createLucideIcon('GroupAdd', UserRoundPlus);
export const ManageAccountsOutlinedIcon = /* #__PURE__ */ createLucideIcon('ManageAccountsOutlined', UserCog);
// MUI Face is a stylised face used as an avatar placeholder; Lucide's nearest is Smile.
export const FaceIcon = /* #__PURE__ */ createLucideIcon('Face', Smile);
export const FaceOutlinedIcon = /* #__PURE__ */ createLucideIcon('FaceOutlined', Smile);
